module.exports = __webpack_public_path__ + "static/media/banner_02_sm.a7c07ce6.jpg";